import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getPrices,
    getTags,
    createPrice,
    updatePrice,
    deletePrice
}

function getPrices(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/prices`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getTags() {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/prices/tags`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createPrice(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/prices`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updatePrice(priceId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/prices/${priceId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deletePrice(priceId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/prices/${priceId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}